import map from 'lodash/map';

import getBasic from './basic';
import { IvrConfiguration } from 'src/presentation/components/pages/ivr/components/ivrTree/config/ivrConfig';
import getMessageOnly from './messageOnly';
import getProactiveVoice from './proactiveVoice';
import getVoicemailOnly from './voicemailOnly';

export enum IvrTemplateType {
  Basic = 'BASIC_IVR_TEMPLATE',
  ProactiveVoice = 'PROACTIVE_VOICE_IVR_TEMPLATE',
  VoicemailOnly = 'VOICEMAIL_ONLY_IVR_TEMPLATE',
  MessageOnly = 'MESSAGE_ONLY_IVR_TEMPLATE',
}

export type IvrTemplate = {
  description: string;
  getTemplate: ({
    baseId,
    orgTimezone,
    orgUrl,
  }: {
    baseId: string;
    orgTimezone?: string;
    orgUrl?: string;
  }) => IvrConfiguration;
  name: string;
  treeNodeLabel: string;
};

const IvrTemplates: Record<IvrTemplateType, IvrTemplate> = {
  [IvrTemplateType.Basic]: {
    description: 'Get started with IVR fundamentals',
    getTemplate: ({ baseId, orgTimezone }) => getBasic(baseId, orgTimezone) as IvrConfiguration,
    name: 'baseTemplate',
    treeNodeLabel: 'Basic IVR',
  },
  [IvrTemplateType.ProactiveVoice]: {
    description: 'Use this IVR for Proactive Voice campaigns',
    getTemplate: ({ baseId }) => getProactiveVoice(baseId) as IvrConfiguration,
    name: 'proactiveVoiceTemplate',
    treeNodeLabel: 'Proactive Voice',
  },
  [IvrTemplateType.VoicemailOnly]: {
    description: 'Opt to accept voicemails only for callback purposes',
    getTemplate: ({ baseId }) => getVoicemailOnly(baseId) as IvrConfiguration,
    name: 'voiceOnlyTemplate',
    treeNodeLabel: 'Voicemail Only',
  },
  [IvrTemplateType.MessageOnly]: {
    description: 'Automatically play a message when customers call in',
    getTemplate: ({ baseId }) => getMessageOnly(baseId) as IvrConfiguration,
    name: 'messageOnlyTemplate',
    treeNodeLabel: 'Message Only',
  },
};

export const IvrTemplateList = map(
  Object.entries(IvrTemplates),
  ([typeOfIvr, template]: [IvrTemplateType, IvrTemplate]) => ({
    ...template,
    id: typeOfIvr,
  })
);

export default IvrTemplates;
